// extracted by mini-css-extract-plugin
export default {"textAlignment":"q9iguh","moreOptions":"edNMkQ","mobileMoreOptions":"zmJg2w"};